 import "../styles/eventsSinglePage.css";
import { FaCalendarAlt } from "react-icons/fa";
import { AiOutlineClockCircle } from "react-icons/ai";
import { FaRegClone } from "react-icons/fa";
   import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
 
 

const EventSingleLoader = () => {
 
 
   

  return (
    <div>
      <div className="single-event-container">
        <div
          className="events-skeleton-loader"
 
        >
      <Skeleton width="100%" height="100%" />
         
        </div>

        <div className="event-wrapper">
          <div className="event-details">
            <div className="event-single-card">
             
              <div>
               <Skeleton width="200px" height="15px" />
                <p className="value">
                <Skeleton width="200px" height="15px" />    
                 </p>
              </div>
            </div>

            <div className="event-single-card">
              
              <div>
                <Skeleton width="200px" height="15px" />
                <p className="value">
                <Skeleton width="200px" height="15px" />
                </p>
              </div>
            </div>

            <div className="event-single-card">
               
              <div>
                <Skeleton width="200px" height="15px" />
                <p className="value">
                   <Skeleton width="200px" height="15px" />
                    </p>
              </div>
            </div>

            <div className="event-single-card">
            
              <div>
                                <Skeleton width="200px" height="15px" />

                <Skeleton width="200px" height="15px" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="event-single-details-wrapper">
        <div className="event-overview">
          <Skeleton width="200px" height="30px" style={{marginBottom:"10px"}} />
          
          <Skeleton width="90%" height="15px" />
         <Skeleton width="95%" height="15px" />
        <Skeleton width="100%" height="15px" />
         <Skeleton width="85%" height="15px" />

        </div>
        <div className="event-booking-container">
         
      <div className="event-booking-card">
        <div className="price-section">
          <span className="price-label">
            <Skeleton width="100%" height="25px" />
          </span>
          <span className="price">
            <Skeleton width="200px" height="25px" />
          </span>
        </div>

         
          <Skeleton width="280px" height="15px" />
        

         
             <Skeleton width="300px" height="15px" />
         

        
              <Skeleton width="250px" height="15px" />
           
        

       
       
      </div>
       </div>
      </div>

   

    </div>
  );
};

export default EventSingleLoader;
